import {Field, reduxForm} from "redux-form";
import PropTypes from "prop-types";
import React from "react";
import FormCheckBox from "../form/FormCheckBox";
import FormSelect from "../form/FormSelect";

const validation = (values = {}) => {

  const errors = {};
  const requiredFields = [
    "sourceTenantId",
  ];

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Pole jest wymagane';
    }
  });

  if (!values.importPreferredBikeReturnZone && !values.importOperationsZone) {
    const msg = "Zaznacz przynajmniej jedną z opcji";
    errors["importPreferredBikeReturnZone"] = msg;
    errors["importOperationsZone"] = msg;
  }
  return errors;
};


let importZonesForm = ({handleSubmit, tenants}) => {
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <Field
          name="importOperationsZone"
          component={FormCheckBox}
          label="Importuj strefę działania"
        />
      </div>
      <div>
        <Field
          name="importPreferredBikeReturnZone"
          component={FormCheckBox}
          label="Importuj strefy oddania"
        />
      </div>
      <div>
        <Field
          name="importIcon"
          component={FormCheckBox}
          label="Importuj ikony"
        />
      </div>
      <div>
        <Field
          name="sourceTenantId"
          component={FormSelect}
          label="Tenant źródłowy"
          style={{width: "100%"}}
          values={tenants.map((x) => ({
            value: x.id,
            name: x.id,
          }))}
        />
      </div>
    </form>
  );
};

importZonesForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  tenants: PropTypes.array.isRequired,
};

importZonesForm = reduxForm({
  form: 'importZonesForm',
  validate: validation,
})(importZonesForm);

export default importZonesForm;
